requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded('cart.js', () => {
      class CartNotification extends HTMLElement {
        constructor() {
          super();

          this.notification = document.getElementById('cart-notification');
          this.onBodyClick = this.handleBodyClick.bind(this);

          subscribe(PUB_SUB_EVENTS.cartUpdateFinish, this.show.bind(this));
          this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
          this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.addEventListener('click', this.close.bind(this))
          );
        }

        show() {
          this.notification.classList.add('animate', 'active');

          this.notification.addEventListener('transitionend', () => {}, {
            once: true
          });

          document.body.addEventListener('click', this.onBodyClick);
        }

        close() {
          this.notification.classList.remove('active');
          document.body.removeEventListener('click', this.onBodyClick);
        }

        handleBodyClick(event) {
          const target = event.target;
          if (target !== this.notification && !target.closest('cart-notification')) {
            this.close();
          }
        }
      }

      customElements.define('cart-notification', CartNotification);
    });
  });
});